import React from "react";
import PropTypes from "prop-types";

class AddressDisplay extends React.Component {
    render() {
        return this.props.address.formatted_string;
    }
}

AddressDisplay.propTypes = {
    address: PropTypes.object
};

export default AddressDisplay;
